export default __webpack_public_path__ + "static/media/TOTAL.35bbd14e.gif";